'use strict';
(self.webpackChunkthe_woobles = self.webpackChunkthe_woobles || []).push([
  [263],
  {
    3030: function (e, t, s) {
      var n = s(1864),
        l = (e) => {
          const t = e.querySelector('.js-step-by-step-items');
          t &&
            (() => {
              const e = 'empty',
                s = 'last',
                n = 'last-row',
                l = t.getAttribute('data-column'),
                r = [...t.querySelector('table').querySelectorAll('td')].reverse();
              if (!r.length) return;
              r.forEach((t) => {
                (t.classList.remove(e),
                  t.classList.remove(s),
                  t.classList.remove(n),
                  t.innerText.replace(/\\n/g, '').trim() || ((t.isEmpty = !0), t.classList.add(e)));
              });
              const c = r.filter((e) => e.isEmpty);
              if (c.length && (r.length && r[c.length].classList.add(s), c.length >= l)) {
                const e = l - (c.length % l) + c.length;
                r.forEach((t, s) => {
                  s < e && !t.isEmpty && t.classList.add(n);
                });
              }
            })();
        };
      document.addEventListener('DOMContentLoaded', () => {
        (0, n.u)(l, 'step-by-step');
      });
    },
  },
  function (e) {
    e.O(0, [223], function () {
      return ((t = 3030), e((e.s = t)));
      var t;
    });
    e.O();
  },
]);
